import { render, staticRenderFns } from "./qs4-06.vue?vue&type=template&id=535f8c35&scoped=true&"
import script from "./qs4-06.vue?vue&type=script&lang=js&"
export * from "./qs4-06.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535f8c35",
  null
  
)

export default component.exports